/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Thu May 05 2022
*  File : main.ts
*******************************************/

import { PropertyConfig } from "@api-commons/config/PropertyConfig.js";


import { PushServiceInterface } from "@api-commons/subscriptions/PushServiceInterface.js";

import { FanpageSdkGui } from "../gui/FanpageSdkGui.js";
import { AbstractModuleAutoloadManager } from "@api-commons/modularization/AbstractModuleAutoloadManager.js";
import { SdkGuiController } from "@api-commons/gui/guiControllers/SdkGuiController.js";
import { DefaultGuiServiceInjector } from "@api-commons/gui/serviceInjectors/DefaultGuiServiceInjector.js";
import { CatalogueLanguages } from "@ciaopeople/cp-shatsu/Catalogue";
export class FanpageAutoloader extends AbstractModuleAutoloadManager {
    
    constructor(
        win: WindowProxy,
        config: PropertyConfig,
        private guiRenderTarget: Element | Document = null
    ) {
        super(win, config);
    }


    public getGui(): Promise<FanpageSdkGui> {
        return super.getGui().then(
            g => g as FanpageSdkGui
        );
    }

    protected initSdkClient(): Promise<any> {
        return import(/* webpackChunkName: "fanpage/it/sdk/sdk-client" */ "./SdkClient.js").then(
            ({ SdkClient }) => {
                return SdkClient(this.configHelper.getOriginal(), this);
            }
             
        );
    }

    protected initSdkServer(): Promise<any> {
        return this.injectScript(this.configHelper.getSdkJsServerUrl(), "fp-sdk-server");
    }

    protected initPushHelper(): Promise<PushServiceInterface> {
        return this.getSdkClient().then(
            (sdk) => {
                return sdk.pushNotificationService;
            }
        );
    }


    protected initGui(): Promise<SdkGuiController> {
        if (this.guiRenderTarget === null) {
            return Promise.reject("GUI Target not set");
        }

        return this.getSdkClient().then(
            sdk => {
                const gui = import(/* webpackChunkName: "fanpage/it/sdk/gui" */ './GUI.js');
                
                return gui.then(
                    ({ GUI }) => {
                        return GUI(
                            this.guiRenderTarget,
                            new DefaultGuiServiceInjector(CatalogueLanguages.it, this.configHelper.getOriginal(), sdk.getStatsCollector())
                        );
                    }
                );

            }
        );
    }


   

}